import React from "react";
import "../styles/AboutMe.css";
import Statistics from "../components/Statistics";
import contentData from "../data/content.json";
import Profile from "../assets/images/about/profile.jpg"; // Replace with actual profile image path

const AboutMe = () => {
    const { about } = contentData;

    return (
        <div className="about-container">
            {/* Hero About Section - Split Layout */}
            <div className="about-hero-section">
                <div className="about-hero-image">
                    <img
                        src={Profile}
                        alt={about.name}
                        className="about-full-image"
                    />
                    <div className="about-image-overlay"></div>
                </div>
                <div className="about-hero-content">
                    <h2 className="about-hero-title">
                        {about.heroTitle || "Building a community through "}
                        <span className="about-hero-title-italic">adventure</span>
                    </h2>
                    <p className="about-hero-description">
                        {about.heroDescription || "Exploring remote landscapes, documenting untold stories, and inspiring a global community of adventurers to embrace the wild unknown."}
                    </p>
                    <div className="about-stat">
                        <span className="about-stat-number">{about.mainStat || "350K+"}</span>
                        <span className="about-stat-label">{about.mainStatLabel || "Followers"}</span>
                    </div>
                    <button className="about-cta-button" onClick={() => window.scrollTo({ top: document.querySelector('.hero-container').offsetHeight, behavior: 'smooth' })}>
                        Check out my Adventures
                    </button>
                </div>
            </div>

            {/* Statistics Section */}
            <Statistics stats={about.statistics} />
        </div>
    );
};

export default AboutMe;
